export default function FieldLines({ className = "", stroke = "rgba(255,255,255,0.16)", accent = true }) {
    return (
        <svg className={`pointer-events-none ${className}`} viewBox="0 0 800 800" fill="none" aria-hidden="true">
            <circle cx="400" cy="400" r="290" stroke={stroke} strokeWidth="1.5" />
            <circle cx="400" cy="400" r="7" stroke={stroke} strokeWidth="1.5" />
            <path d="M400 20 V 780" stroke={stroke} strokeWidth="1" strokeDasharray="5 9" />
            <path d="M20 400 H 780" stroke={stroke} strokeWidth="1" />
            <rect x="320" y="250" width="160" height="300" stroke={stroke} strokeWidth="1" />
            <path d="M110 400 A 290 290 0 0 1 400 110" stroke={stroke} strokeWidth="1.5" strokeDasharray="2 10" />
            {accent && <path d="M390 400 h20 M400 390 v20" stroke="#D60024" strokeWidth="3" />}
        </svg>
    );
}
